import { Component, OnInit } from '@angular/core';
import { NgbModalRef, NgbActiveModal } from '@otas/modal/modal-ref';
import { NgbModal } from '@otas/modal/modal';
import { ExpenseHead } from '@otas/model/expense-head';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ProductModalService } from './product-modal.service';
import { AppConstants } from '../../../app.constants';
import * as _ from 'underscore';
import { GlobalData } from '../../../globalData';
@Component({
    selector: 'app-product-modal',
    templateUrl: './product-modal.component.html',
    styleUrls: ['./product-modal.component.css'],
    providers: [ProductModalService],
    standalone: false
})
export class ProductModalComponent implements OnInit {
  submitted = false;
  expenseHeadForm: UntypedFormGroup;
  allUnitList: any[] = [];
  modalRef: NgbModalRef;
  heading;
  data;
  buttonName;
  materialCategory;
  submitting = false;
  allExpenseAccountsList: any[] = [];
  allIncomeAccountsList: any[] = [];
  allStoreList: any = [] = [];
  userData;
  allMaterialCategory: any = [] = [];
  category;
  categoryType: string;
  selectedItems: any[] = [];
  constructor(public activeModal: NgbActiveModal, private fb: UntypedFormBuilder, private modalService: NgbModal,
    private productModalService: ProductModalService) {
    this.expenseHeadForm = fb.group(new ExpenseHead());
    this.userData = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
  }

  onSelect($event)  {  //  //*ngIf="selectedItems?.length > 0"  //(selected)="onSelect($event)"
    this.selectedItems = $event;
  }

  ngOnInit() {
    this.expenseHeadForm.get('category').setValue([]);
    this.expenseHeadForm.get('isStockUpdate').setValue(false);
    this.expenseHeadForm.get('showStockOption').setValue(false);
    this.getAllUnit();
    this.getAllMaterialCategory();
    this.getAllExpenseAccount();
    this.getAllIncomeAccount();
    this.getAllStore();   
    if (!!this.data) {      
      if (!!this.data.categoryId) {
        this.category = this.data.categoryId.split(',');
      }
      const obj = _.omit(this.data, 'accountHeadName', 'incomeAccountHeadName', 'categoryId', 'categoryType', 'templeId', 'unitName', 'categoryName');
      obj.category = [];
      if (!!this.category) {
        this.category.forEach(element => {
          obj.category.push(element * 1);
        });
        this.selectedItems = obj.category;
      }
      this.expenseHeadForm.setValue(obj);
    }
  }
  isStockUpdate(event) {
    this.expenseHeadForm.get('isStockUpdate').setValue(!!this.expenseHeadForm.get('isStockUpdate').value ? false : true);
  }
  showStockOption(event)  {
    this.expenseHeadForm.get('showStockOption').setValue(!!this.expenseHeadForm.get('showStockOption').value ? false : true);
  }
  isCostChanging(event)  {
    this.expenseHeadForm.get('isCostChanging').setValue(!!this.expenseHeadForm.get('isCostChanging').value ? false : true);
  }
  add() {
    if (this.expenseHeadForm.invalid) {
      this.submitted = true;
      return;
    }
    this.productModalService.addMaterial(this.expenseHeadForm.value).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.expenseHeadForm.reset();
        this.submitted = false;
        this.activeModal.close(true);
      }
    });
  }
  getAllUnit() {
    !!GlobalData.menus[0].array.length ? this.allUnitList = GlobalData.menus[0].array : this.allUnitList = [];
    this.productModalService.getAllUnit().subscribe(response => {
      this.allUnitList = response.result;

    });
  }
  getAllExpenseAccount() {
    this.productModalService.getAllExpenseAccount().subscribe(response => {
      this.allExpenseAccountsList = response.result;
    });
  }
  getAllIncomeAccount() {
    this.productModalService.getAllIncomeAccount().subscribe(response => {
      this.allIncomeAccountsList = response.result;
    });
  }
  getAllMaterialCategory() {
    this.productModalService.getAllMaterialCategory().subscribe(response => {
      this.allMaterialCategory = response.result;
    });
  }
  getAllStore() {
    this.productModalService.getAllStore().subscribe(response => {
      this.allStoreList = response.result;
    });
  }
  addCategoryModalOpen(content) {

    this.submitting = false;
    this.materialCategory = null;
    this.modalRef = this.modalService.open(content);
  }
  submitMaterialCategory() {
    if (!this.materialCategory) {
      this.submitting = true;
      return;
    }
    this.productModalService.submitMaterialCategory(this.materialCategory).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.modalRef.close();
        this.getAllMaterialCategory();
      }
    });
  }
}

